import gql from 'graphql-tag'

export const WELCOMES_QUERY = gql`
  query WelcomesQuery($limit: Int, $offset: Int, $q: String) {
    welcomes(limit: $limit, offset: $offset, q: $q) {
      id
      info
      ctaText
      ctaAction
      active
      created
      updated
    }
  }
`

export const UPDATE_WELCOME_MUTATION = gql`
  mutation UpdateWelcomeMutation($id: ID!, $input: UpdateWelcomeInput!) {
    updateWelcome(id: $id, input: $input) {
      id
      info
      active
    }
  }
`

export const DELETE_WELCOME = gql`
  mutation DeleteWelcomeMutation($id: ID!) {
    deleteWelcome(id: $id) {
      id
    }
  }
`

export const TAGS_QUERY = gql`
  query TagsQuery($limit: Int, $offset: Int, $q: String) {
    tags(limit: $limit, offset: $offset, q: $q) {
      id
      name
      visible
    }
  }
`

export const CREATE_TAG_MUTATION = gql`
  mutation CreateTagMutation($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      name
      visible
    }
  }
`

export const UPDATE_TAG_MUTATION = gql`
  mutation UpdateTagMutation($id: ID!, $input: UpdateTagInput!) {
    updateTag(id: $id, input: $input) {
      id
      name
      visible
    }
  }
`

export const CREATE_CONTENT_MUTATION = gql`
  mutation CreateContent($input: CreateContentInput!, $files: Upload) {
    createContent(input: $input, files: $files) {
      id
      title
      description
      imgUrl
      videoUrl
      template
      contentType
      category
      nodeName
      editorState
      tags {
        id
        name
      }
      sources {
        name
        url
      }
      body {
        header
        text
        imgUrl
      }
    }
  }
`

export const FIND_CONTENT = gql`
  query FindContent($id: ID!) {
    content(id: $id) {
      id
      title
      description
      imgUrl
      videoUrl
      template
      contentType
      category
      nodeName
      editorState
      publishedTime
      tags {
        id
        name
      }
      sources {
        name
        url
      }
      body {
        header
        text
        imgUrl
      }
    }
  }
`

export const UPDATE_CONTENT_MUTATION = gql`
  mutation UpdateContent(
    $id: ID!
    $input: UpdateContentInput!
    $files: Upload
  ) {
    updateContent(id: $id, input: $input, files: $files) {
      id
      title
      description
      imgUrl
      videoUrl
      template
      contentType
      category
      nodeName
      editorState
      publishedTime
      tags {
        id
        name
      }
      sources {
        name
        url
      }
      body {
        header
        text
        imgUrl
      }
    }
  }
`

export const CONTENTS_QUERY = gql`
  query ContentsQuery(
    $offset: Int = 0
    $limit: Int = 20
    $q: String
    $order: String = "updated"
    $tags: String
    $featuredType: String
  ) {
    contents(
      offset: $offset
      limit: $limit
      q: $q
      order: $order
      tags: $tags
      featuredType: $featuredType
    ) {
      id
      title
      category
      template
      contentType
      updated
      publishedTime
      featuredType
      isFeatured
      editorState
      lastModifiedBy {
        firstName
        lastName
      }
    }
  }
`

export const DELETE_CONTENT = gql`
  mutation DeleteContent($id: ID!) {
    deleteContent(id: $id) {
      id
    }
  }
`

export const TOPICS_QUERY = gql`
  query TopicsQuery {
    topics {
      id
      name
      count
    }
  }
`

export const MESSAGES_QUERY = gql`
  query MessagesQuery($limit: Int = 20, $offset: Int = 0) {
    messages(limit: $limit, offset: $offset) {
      id
      sentAt
      scheduled
      updated
      topic
      data {
        type
        name
      }
    }
  }
`

export const MESSAGE_QUERY = gql`
  query MessagesQuery($id: ID!) {
    message(id: $id) {
      id
      topic
      title
      text
      userIds
      data {
        type
        name
        content
        imgUrl
        webUrl
        cta
        ctaText
        category
        param
        campaignId
      }
    }
  }
`

export const EVENTS_QUERY = gql`
  query EventsQuery($limit: Int = 1000, $offset: Int = 0) {
    events(limit: $limit, offset: $offset) {
      id
      title
      description
      location
      address
      imgUrl
      startTime
      active
    }
  }
`

export const FIND_EVENT_QUERY = gql`
  query FindEventQuery($id: ID!) {
    eventData: event(id: $id) {
      id
      title
      description
      location
      webinarUrl
      imgUrl
      address
      lat
      lng
      eventStartTime
      eventEndTime
      price
    }
  }
`

export const CREATE_EVENT_MUTATION = gql`
  mutation CreateEventMutation($input: UpdateEventInput!, $file: Upload) {
    createEvent(input: $input, file: $file) {
      id
    }
  }
`

export const UPDATE_EVENT_MUTATION = gql`
  mutation UpdateEventMutation(
    $id: ID!
    $input: UpdateEventInput!
    $file: Upload
  ) {
    updateEvent(id: $id, input: $input, file: $file) {
      id
    }
  }
`

export const FIND_POLL_QUERY = gql`
  query FindPollQuery($id: ID!) {
    poll(id: $id) {
      id
      question
      explanation
      url
      urlText
      answers {
        id
        answer
        result
        isCorrect
      }
    }
  }
`
